var giphy_viewer_default = {
  "giphyWrapper": "xE543",
  "giphy_player": "Ju-P5",
  "playIcon": "_9Wl8s",
  "gifRatio": "bjtYR"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
